import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { registerServiceWorker } from "./lib/sw";
import "./index.css";

// Cache-bust: an actual statement, not a comment — comments get stripped
// by the production minifier and don't change the built bundle's content
// hash at all (confirmed live 2026-08-12: two comment-only edits produced
// byte-identical output). Cloudflare dedupes uploaded assets by content
// hash account-wide, so this bundle needed a REAL content change to force
// re-upload under the corrected MIME type (see private/auth's
// assetUpload.ts fixes, same date). Safe to remove once app.pure.dev
// confirms rendering correctly.
if (typeof window !== "undefined") {
  (window as unknown as Record<string, string>).__PURE_BUILD__ =
    "cache-bust-v3";
}

// Register the Service Worker as early as possible so the token vault is ready.
registerServiceWorker().catch((err) => {
  // eslint-disable-next-line no-console
  console.error("SW registration failed:", err);
});

const root = createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
